export default "__VITE_ASSET__B8bMSebv__"